"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Span = void 0;
class Span {
    constructor(speech, attributes) {
        this.speech = speech;
        this.attributes = attributes;
    }
}
exports.Span = Span;
